import { useNavigate, useLocation } from 'react-router-dom';
import { Badge, IconButton, Button } from '@mui/material';
import { NotificationsNone, AccountCircle, Add } from '@mui/icons-material';
import { ShmoozNavbarLogo } from '../../assets/images';
import '../../styles/user-dashboard/UserNavbar.css';

export default function UserDashboardNavbar() {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    function handleNewEventCreation() {
        navigate('/event/new/event-details');
    }

    return (
        <nav id="user-dashboard-navbar">
            <div className="user-dashboard-navbar-wrapper">
                <div className="user-dashboard-navbar-logo">
                    <a href="/">
                        <img src={ShmoozNavbarLogo} alt="Shmooz" />
                    </a>
                </div>

                <div className="user-dashboard-navbar-actions">

                    {pathname !== '/event/new/event-details' && (
                        <Button variant="text" startIcon={<Add />} onClick={handleNewEventCreation}>
                            Create Event
                        </Button>
                    )}

                    <IconButton>
                        <Badge badgeContent={4} color="secondary">
                            <NotificationsNone />
                        </Badge>
                    </IconButton>

                    <IconButton color="tertiary">
                        <AccountCircle />
                    </IconButton>
                </div>
            </div>
        </nav>
    );
}
